module.exports = __webpack_public_path__ + "static/media/safari.3f2f3e56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/safari.png
// module id = 182
// module chunks = 0